import dayjs from "dayjs";

/* =========================================================
✅ SPECIAL PERMISSION STRING → OBJECT (FOR API REQUEST)
========================================================= */
const buildSpecialPermissionObject = (text = "") => {
  const selected = String(text)
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);

  const config = [
    { key: "underSec46", label: "Under Section 46" },
    { key: "firstCheck", label: "First Check" },
    { key: "greenChannel", label: "Green Channel" },
    { key: "kachhaBE", label: "Kachha B/E" },
    { key: "underSec48", label: "Under Sec 48" },
    { key: "provisionalAssessment", label: "Provisional Assessment" },
  ];

  const result = {};

  config.forEach((item) => {
    const isSelected = selected.includes(item.label);

    result[item.key] = {
      isSelected,
      value: isSelected ? item.label : "",
    };
  });

  return result;
};

/* =========================================================
✅ SPECIAL PERMISSION OBJECT → STRING (FOR FORM DISPLAY)
========================================================= */
const buildSpecialPermissionString = (obj = {}) => {
  if (!obj || typeof obj !== "object") return "";

  return Object.values(obj)
    .filter((item) => item?.isSelected === true)
    .map((item) => item?.value)
    .filter(Boolean)
    .join(", ");
};

/* =========================================================
✅ MAIN REQUEST MAPPER (FORM → API)
========================================================= */
export const mapImporterRequest = (formData) => {
  // ---------- importJob section ----------
  const importJobFields = [
    "importJobDate",
    "importJobReceivedOn",
    "importJobBENo",
    "importJobTransportMode",
    "importJobCustomHouse",
    "importJobOwner",
    "importJobBEType",
    "importJobFillingMode",
    "importJobFillingModeType",
    "importJobConsignmentType",
  ];

  // ---------- importGeneral section ----------
  const importGeneralFields = [
    "importerId",
    "importerAddressId",
    "importerAddress",
    "importerGeneralBranchSNO",
    "importerGeneralState",
    "importerGeneralIECodeNo",
    "importerGeneralADCode",
    "importerGeneralRegnNoType",
    "importerGeneralRegnNumber",
    "importerGeneralRegnNumberState",
    "importerGeneralRefNo",
    "importerGeneralAirCustodian",
    "importerGeneralCFS",
    "importerGeneralPortOfShipment",
    "importerGeneralCountryOfShipment",
    "importerGeneralCountryOfOrigin",
    "importerGeneralFinalDestination",
    "importerGeneralBEHeading",
    "importerGeneralQuotation",
    "importerGeneralSalesPerson",
    "importerGeneralPaymentMethod",
    "importerGeneralClearedUnderRMS",
    "importerGeneralUCRType",
    "importerGeneralUCRTypeNo",
    "importerGeneralRefType",
    "importerGeneralRefTypeValue",
    "importerGeneralDocFillingStatus",
    "importerGeneralTranshipment",
    "importerGeneralSpecialPermission", // ✅ transformed
    "importerGeneralSpecialPermissionButton",
    "importerGeneralBENumber",
    "importerGeneralBENumberDate",
    "importGeneralIsHighSeaSale",
    "importGeneralHSSLevel0",
    "importGeneralHSSSellerName",
    "importerGeneralHSSAddressId",
    "importerGeneralHSSAddress",
    "importerGeneralHSSBranchSNO",
    "importerGeneralHSSIECodeNo",
    "importerGeneralHSSCity",
    "importerGeneralHSSPostalCode",
    "importerGeneralHSSCountry",
    "importerGeneralHSSADCode",
  ];

  /* ✅ UNIVERSAL OBJECT BUILDER */
  const buildObject = (fields, sectionName) => {
    return fields.reduce((acc, key) => {
      const val = formData[key];

      if (
        val !== undefined &&
        val !== null &&
        val !== "" &&
        val !== "-" &&
        !(typeof val === "object" && Object.keys(val).length === 0)
      ) {
        // ✅ DATE VALIDATION
        if (
          [
            "importJobDate",
            "importJobReceivedOn",
            "importerGeneralBENumberDate",
          ].includes(key)
        ) {
          const validFormats = [
            "YYYY-MM-DD",
            "DD-MM-YYYY",
            "YYYY-MM-DDTHH:mm:ss.SSSZ",
          ];

          let isValidDate = false;

          if (val?.$d) isValidDate = true;
          else if (typeof val === "string") {
            const parsed = dayjs(val, validFormats, true);
            if (parsed.isValid()) isValidDate = true;
          }

          if (!isValidDate) {
            console.warn(
              `⚠️ [${sectionName}] Invalid date skipped: ${key} =`,
              val
            );
            return acc;
          }
        }

        // ✅ ✅ SPECIAL PERMISSION TRANSFORM (STRING → OBJECT)
        if (key === "importerGeneralSpecialPermission") {
          acc[key] = buildSpecialPermissionObject(val);
        } else {
          acc[key] = val;
        }
      }

      return acc;
    }, {});
  };

  const importJob = buildObject(importJobFields, "importJob");
  const importGeneral = buildObject(importGeneralFields, "importGeneral");

  const finalPayload = {
    importRequest: {
      processingId: formData.processingId,
      importJob,
      importGeneral,
    },
  };

  console.log(
    "✅ [mapImporterRequest] Final mapped payload ready:",
    finalPayload
  );

  return finalPayload;
};

/* =========================================================
✅ RESPONSE MAPPER (API → FORM)
========================================================= */
// export const mapImporterFormResponse = (formData) => {
//   if (!formData) return {};

//   return {
//     processingId: formData.processingId,
//     value: formData.importerGeneralId,
//     importerGeneralId: formData.importerGeneralId,
//     importJobId: formData.importJobId,
//     importJobNumber: formData.importJobNumber,

//     // --- Job ---
//     importJobDate: formData.importJobDate,
//     importJobReceivedOn: formData.importJobReceivedOn,
//     importJobBENo: formData.importJobBENo,
//     importJobTransportMode: formData.importJobTransportMode,
//     importJobCustomHouse: formData.importJobCustomHouse,
//     importJobOwner: formData.importJobOwner,
//     importJobBEType: formData.importJobBEType,
//     importJobFillingMode: formData.importJobFillingMode,
//     importJobFillingModeType: formData.importJobFillingModeType,
//     importJobConsignmentType: formData.importJobConsignmentType,
//     importJobStatus: formData.importJobStatus,
//     importEntryDate: formData.importEntryDate,

//     // --- Importer ---
//     importerId: formData.importerId,
//     importerName: formData.importerName,
//     importerAddressId: formData.importerAddressId,
//     importerAddress: formData.importerAddress,
//     importerGeneralBranchSNO: formData.importerGeneralBranchSNO,
//     importerGeneralIECodeNo: formData.importerGeneralIECodeNo,
//     importerGeneralADCodeId: formData.importerGeneralADCodeId,
//     importerGeneralADCode: formData.importerGeneralADCode,

//     // --- ✅ SPECIAL PERMISSION OBJECT → STRING (DISPLAY) ---
//     importerGeneralSpecialPermission:
//       buildSpecialPermissionString(
//         formData.importerGeneralSpecialPermission
//       ),

//     importerGeneralTranshipment: formData.importerGeneralTranshipment,
//     importerGeneralStatus: formData.importerGeneralStatus,
//     importerCity: formData.importerCity,
//     importerState: formData.importerState,
//     importerCountry: formData.importerCountry,
//   };
// };


export const mapImporterFormResponse = (formData) => {
  if (!formData) return {};


  return {
    processingId: formData.processingId,
    value: formData.importerGeneralId,
    importerGeneralId: formData.importerGeneralId,
    importJobId: formData.importJobId,
    importJobNumber: formData.importJobNumber,

    // --- Job related ---
    importJobDate: formData.importJobDate,
    importJobReceivedOn: formData.importJobReceivedOn,
    importJobBENo: formData.importJobBENo,
    importJobTransportMode: formData.importJobTransportMode,
    importJobCustomHouse: formData.importJobCustomHouse,
    importJobOwner: formData.importJobOwner,
    importJobBEType: formData.importJobBEType,
    importJobFillingMode: formData.importJobFillingMode,
    importJobFillingModeType: formData.importJobFillingModeType,
    importJobConsignmentType: formData.importJobConsignmentType,
    importJobStatus: formData.importJobStatus,
    importEntryDate: formData.importEntryDate,

    // --- Importer related ---
    importerId: formData.importerId,
    importerName: formData.importerName,
    importerAddressId: formData.importerAddressId,
    importerAddress: formData.importerAddress,
    importerGeneralBranchSNO: formData.importerGeneralBranchSNO,
    importerGeneralIECodeNo: formData.importerGeneralIECodeNo,
    importerGeneralADCodeId: formData.importerGeneralADCodeId,
    importerGeneralADCode: formData.importerGeneralADCode,
    importerGeneralPortOfShipmentId: formData.importerGeneralPortOfShipmentId,
    importerGeneralPortOfShipment: formData.importerGeneralPortOfShipment,
    importerGeneralCountryOfShipmentId:
      formData.importerGeneralCountryOfShipmentId,
    importerGeneralCountryOfShipment: formData.importerGeneralCountryOfShipment,
    importerGeneralCountryOfOriginId: formData.importerGeneralCountryOfOriginId,
    importerGeneralCountryOfOrigin: formData.importerGeneralCountryOfOrigin,
    importerGeneralFinalDestinationId:
      formData.importerGeneralFinalDestinationId,
    importerGeneralFinalDestination: formData.importerGeneralFinalDestination,

    // --- General info ---
    importerGeneralBENumber: formData.importerGeneralBENumber,
    importerGeneralBENumberDate: formData.importerGeneralBENumberDate,
    importerGeneralBEHeading: formData.importerGeneralBEHeading,
    importerGeneralRefNo: formData.importerGeneralRefNo,
    importerGeneralQuotation: formData.importerGeneralQuotation,
    importerGeneralSalesPerson: formData.importerGeneralSalesPerson,
    importerGeneralPaymentMethod: formData.importerGeneralPaymentMethod,
    importerGeneralUCRType: formData.importerGeneralUCRType,
    importerGeneralUCRTypeNo: formData.importerGeneralUCRTypeNo,
    importerGeneralRefType: formData.importerGeneralRefType,
    importerGeneralRefTypeValue: formData.importerGeneralRefTypeValue,
    importerGeneralRegnNoType: formData.importerGeneralRegnNoType,
    importerGeneralRegnNumber: formData.importerGeneralRegnNumber,
    importerGeneralRegnNumberState: formData.importerGeneralRegnNumberState,
    importerGeneralAirCustodian: formData.importerGeneralAirCustodian,
    importerGeneralClearedUnderRMS: formData.importerGeneralClearedUnderRMS,
    importerGeneralDocFillingStatus: formData.importerGeneralDocFillingStatus,
    importerGeneralTranshipment: formData.importerGeneralTranshipment,
    importerGeneralSpecialPermission:
      buildSpecialPermissionString(
        formData.importerGeneralSpecialPermission
      ),

    // --- HSS (High Sea Sale) info ---
    importGeneralIsHighSeaSale: formData.importGeneralIsHighSeaSale,
    importGeneralHSSLevel0: formData.importGeneralHSSLevel0,
    importGeneralHSSSellerNameId: formData.importGeneralHSSSellerNameId,
    importGeneralHSSSellerName: formData.importGeneralHSSSellerName,
    importerGeneralHSSAddressId: formData.importerGeneralHSSAddressId,
    importerGeneralHSSAddress: formData.importerGeneralHSSAddress,
    importerGeneralHSSBranchSNO: formData.importerGeneralHSSBranchSNO,
    importerGeneralHSSIECodeNo: formData.importerGeneralHSSIECodeNo,
    importerGeneralHSSCity: formData.importerGeneralHSSCity,
    importerGeneralHSSPostalCode: formData.importerGeneralHSSPostalCode,
    importerGeneralHSSCountryId: formData.importerGeneralHSSCountryId,
    importerGeneralHSSCountry: formData.importerGeneralHSSCountry,
    importerGeneralHSSADCodeId: formData.importerGeneralHSSADCodeId,
    importerGeneralHSSADCode: formData.importerGeneralHSSADCode,

    importerGeneralStatus: formData.importerGeneralStatus,
    importerCity: formData.importerCity,
    importerState: formData.importerState,
    importerCountry: formData.importerCountry,
    isInvoiceAvailable : formData.isInvoiceAvailable
  };
};
